/* eslint-disable no-console */
import { Injectable } from '@angular/core';

/**
 * This service helps keep output clean while running tests, allowing
 * the logging to be mocked out without mocking `console` directly.
 */
@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  log(...data: any[]) {
    console.log(...data);
  }

  info(message?: any, ...optionalParams: any[]) {
    console.info(message, ...optionalParams);
  }

  warn(message?: any, ...optionalParams: any[]) {
    console.warn(message, ...optionalParams);
  }

  error(message?: any, ...optionalParams: any[]) {
    console.error(message, ...optionalParams);
  }

  group(...label: any[]) {
    console.group(...label);
  }

  groupEnd() {
    console.groupEnd();
  }
}
